module.exports = __webpack_public_path__ + "c052ee8d82dc504a2dec50a5926cddb4.jpg";